import { Checkbox } from '@foam/buoy/src/components/Checkbox/Checkbox';
import { cn } from '@foam/buoy/src/lib/utils';
import { ReactElement } from 'react';

type CheckboxCardProps = {
  isChecked: boolean;
  onChange: (val: boolean) => void;
  isDisabled?: boolean;
  children: ReactElement;
};

// Force this component to be controlled - otherwise causes issues with checked state ui
export const CheckboxCard = ({
  isChecked,
  onChange,
  isDisabled,
  children,
}: CheckboxCardProps) => {
  return (
    <label
      className={cn(
        'relative flex flex-col cursor-pointer rounded-12 border bg-card-background-color-default px-6 py-3',
        !isDisabled && 'shadow-ground',
        isChecked ? 'border-blue-500' : 'border-card-border-color-default',
        isDisabled && 'pointer-events-none opacity-70',
      )}
    >
      <Checkbox
        checked={isChecked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={isDisabled}
        aria-label="Select"
        className="absolute right-2 top-2"
      />
      <div className="pr-6">{children}</div>
    </label>
  );
};
